import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-navy-800">
      <div className="w-full px-6 sm:px-8 lg:px-16 xl:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.jpg" alt="YouShop" className="h-10 w-auto rounded-lg" />
            </div>
            <p className="text-navy-300 leading-relaxed mb-6">
              {t('footer.desc')}
            </p>
            {/* Social */}
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-navy-300 hover:text-brand-400 hover:border-brand-500/30 transition-all">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-navy-300 hover:text-brand-400 hover:border-brand-500/30 transition-all">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t('footer.product')}</h4>
            <ul className="space-y-3">
              <li><a href="#features" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.features')}</a></li>
              <li><a href="#pricing" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.pricing')}</a></li>
              <li><a href="#delivery" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.delivery')}</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t('footer.company')}</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.about')}</a></li>
              <li><a href="#" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.careers')}</a></li>
              <li><a href="#" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.blog')}</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t('footer.support')}</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.help')}</a></li>
              <li><a href="#" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.contact')}</a></li>
              <li><a href="#" className="text-navy-300 hover:text-brand-400 transition-colors">{t('footer.links.status')}</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-navy-400 text-sm">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="text-navy-400 text-sm hover:text-brand-400 transition-colors">{t('footer.links.privacy')}</Link>
            <Link to="/data-deletion" className="text-navy-400 text-sm hover:text-brand-400 transition-colors">{t('footer.links.dataDeletion')}</Link>
          </div>
          <p className="text-navy-400 text-sm">{t('footer.madeWith')}</p>
        </div>
      </div>
    </footer>
  );
}
